import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { StyledDiv } from '../../../Theme/CommonStyled';
import Skeleton from '../Skeleton';
import Button from '../Button';
import { StyledWrapper } from './style';
import Fade from '../Fade';

type LoadingType = {
  loading: boolean;
  error?: boolean;
  children: React.ReactNode;
  reload?: () => void;
  skeletonType?: 'table' | 'card' | 'box' | 'brand';
};
const LoadingBox: React.FC<LoadingType> = ({
  loading = true,
  reload,
  error,
  skeletonType = 'card',
  children
}) => {
  return loading ? (
    <StyledDiv>
      <Skeleton type={skeletonType} />
    </StyledDiv>
  ) : error ? (
    <StyledWrapper>
      <Button onClick={reload}>دوباره</Button>
    </StyledWrapper>
  ) : (
    <Fade> {children} </Fade>
  );
};

export default LoadingBox;
